exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".codeHeader{\n  width: 200px;\n}\n\n.dealSuccessFinished_link {\n  margin-left: -6px;\n}\n\n.dealSuccessFinished {\n  max-width: 555px;\n  margin: 0 auto 15px;\n  overflow: visible;\n}\n\n.dealSuccessFinished .card {\n  overflow: visible;\n}\n\n.dealSuccessFinished img{\n  position: relative;\n  right: 50px;\n  bottom: 50px;\n  width: 170px;\n}\n", ""]);

// exports
